import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
const fallbackCategories = [{
  name: "Live Concerts",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697006/img/live_concert_pulse.png",
  count: 124
}, {
  name: "Nightclub Sets",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697006/img/underground_club_ritual.webp",
  count: 89
}, {
  name: "VR Immersions",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697006/img/vr_headset_experience.png",
  count: 56
}];
function CoordinateCorners() {
  return <>
      <span aria-hidden="true" className="pointer-events-none absolute left-0 top-0 h-2 w-2 border-l border-t border-[hsl(0_0%_75%/0.3)] transition-colors duration-300" />
      <span aria-hidden="true" className="pointer-events-none absolute right-0 top-0 h-2 w-2 border-r border-t border-[hsl(0_0%_75%/0.3)] transition-colors duration-300" />
      <span aria-hidden="true" className="pointer-events-none absolute left-0 bottom-0 h-2 w-2 border-l border-b border-[hsl(0_0%_75%/0.3)] transition-colors duration-300" />
      <span aria-hidden="true" className="pointer-events-none absolute right-0 bottom-0 h-2 w-2 border-r border-b border-[hsl(0_0%_75%/0.3)] transition-colors duration-300 group-hover:border-[hsl(182_100%_75%)]" />
    </>;
}
function CategoriesConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8">
        {[0, 1, 2].map(i => <div key={i} data-index={i} className="aspect-[4/5] animate-pulse border border-[hsl(0_0%_20%)] bg-[hsl(257_52%_13%)]" />)}
      </div>;
  }
  const items = !error && terms && terms.length > 0 ? terms.slice(0, 3).map((term, idx) => ({
    name: term.name,
    image: term.image_url || fallbackCategories[idx % 3].image,
    count: term.count ?? fallbackCategories[idx % 3].count,
    link: term.link || "#"
  })) : fallbackCategories.map(c => ({
    ...c,
    link: "#"
  }));
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8">
      {items.map((cat, i) => <article data-index={i} key={i} className="group relative flex flex-col">
          {}
          <div className="relative overflow-hidden border border-[hsl(0_0%_20%)] bg-[hsl(257_52%_10%)] transition-colors duration-300 group-hover:border-[hsl(182_100%_75%)]">
            <div className="relative aspect-[4/5] overflow-hidden md:aspect-[4/5]">
              <img src={cat.image} alt={cat.name} loading="lazy" decoding="async" className="h-full w-full object-cover grayscale-[0.2] transition-transform duration-[600ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.05] group-hover:grayscale-0" />
              {}
              <div className="pointer-events-none absolute right-4 top-4 z-10">
                <span className="font-mono text-[11px] font-medium uppercase tracking-[0.2em] text-[hsl(270_100%_93%)]" style={{
              mixBlendMode: "difference"
            }}>
                  ID: {String(cat.count).padStart(3, "0")} ARCHIVES
                </span>
              </div>
              {}
              <div className="pointer-events-none absolute bottom-5 left-5 right-5 z-10">
                <h3 className="font-default text-3xl font-bold leading-[1.1] tracking-tight text-[hsl(270_100%_93%)] md:text-4xl" style={{
              mixBlendMode: "difference"
            }}>
                  {cat.name.split(" ").map((word, wi, arr) => <span key={wi}>
                      {wi === arr.length - 1 ? <em className="italic text-[hsl(182_100%_75%)]" style={{
                  fontStyle: "italic"
                }}>
                          {word}
                        </em> : word}
                      {wi < arr.length - 1 ? " " : ""}
                    </span>)}
                </h3>
              </div>
            </div>
            <CoordinateCorners />
          </div>

          {}
          <div className="mt-6 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span aria-hidden="true" className="block h-px w-16 bg-[hsl(0_0%_20%)]" />
              <span aria-hidden="true" className="block h-1.5 w-1.5 rounded-md bg-[hsl(313_100%_65%)]" />
            </div>
            <Link to={cat.link} className="group/link inline-flex items-center gap-2 font-mono text-[13px] font-medium uppercase tracking-[0.2em] text-[hsl(0_0%_75%)] transition-colors duration-300 hover:text-[hsl(182_100%_75%)]">
              Initiate
              <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover/link:translate-x-1" />
            </Link>
          </div>
        </article>)}
    </div>;
}
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 3,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
export default function CuratedRituals() {
  return <section data-section-id="2139" id="curated-rituals" className="relative overflow-hidden border-t border-[hsl(0_0%_20%)] bg-background text-foreground py-24 md:py-32">
      <div className="mx-auto w-full max-w-[1440px] px-5 md:px-10 lg:px-[4.5rem]">
        {}
        <div className="relative grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-6">
          {}
          <div className="relative z-10 md:col-span-5 lg:col-span-4">
            {}
            <div className="mb-6 flex items-center gap-2">
              <span aria-hidden="true" className="block h-px w-6 bg-[hsl(182_100%_75%)]" />
              <span aria-hidden="true" className="block h-1.5 w-1.5 rounded-md bg-[hsl(313_100%_65%)]" />
            </div>
            <p className="font-mono text-[13px] font-medium uppercase tracking-[0.2em] text-[hsl(0_0%_75%)]">
              § INDEX 02 — THE VAULT
            </p>
            <h3 className="mt-6 font-default text-[clamp(1.75rem,5vw,3.5rem)] font-bold leading-[1.1] tracking-tight text-foreground">
              Three sensory realms,{" "}
              <em className="italic text-[hsl(182_100%_75%)]" style={{
              fontStyle: "italic"
            }}>
                one
              </em>{" "}
              sanctuary.
            </h3>
            <p className="mt-5 max-w-md font-default text-[15px] leading-[1.6] text-[hsl(0_0%_75%)]">
              A catalogued spectrum of high-fidelity event footage, architectural 
              VR immersions, and live broadcast access — each curated for the 
              unapologetic seeker.
            </p>
          </div>

          {}
          <div className="pointer-events-none relative md:col-span-7 lg:col-span-8">
            <div className="relative flex h-full items-center justify-end">
              <span aria-hidden="true" className="select-none font-default font-bold leading-none text-foreground/5" style={{
              fontSize: "clamp(12rem, 22vw, 22rem)"
            }}>
                02
              </span>
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 md:mt-20">
          <EcommerceTermsProvider className="curated-categories-grid-wrapper" wp_term_query={wp_term_query}>
            <CategoriesConsumer />
          </EcommerceTermsProvider>
        </div>

        {}
        <div className="mt-14 flex justify-center md:mt-16">
          <Link to="/VaultPage">
            <Button variant="outline" className="border-[hsl(182_100%_75%)] bg-transparent px-8 py-6 font-mono text-[13px] font-medium uppercase tracking-[0.2em] text-[hsl(182_100%_75%)] shadow-md transition-all duration-200 hover:bg-[hsl(182_100%_75%)] hover:text-[hsl(240_18%_5%)] rounded-md">
              Access All Archives
              <ArrowRight className="ml-2 h-3.5 w-3.5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}